import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Spin } from 'antd';
import { useCurrentUser, UserProvider } from '../../context/UserContext';

// Matches the original (pre-React-Query MobX) flow: gate only on mfaVerified.
// IP whitelist enforcement happens inside useVerifyMfa's navigate after the
// MFA verify response — it's not re-checked at the AuthGate level.
const AuthGate = ({ children }) => {
    const navigate = useNavigate();
    const { user, mfaVerified, isLoading, isError } = useCurrentUser();

    useEffect(() => {
        if (!user) return;
        if (!mfaVerified) {
            navigate(user.mfaSecretExists ? '/mfa/verify' : '/mfa/setup');
        }
    }, [user, mfaVerified, navigate]);

    useEffect(() => {
        if (isError) navigate('/sign-in');
    }, [isError, navigate]);

    if (isLoading || !user) {
        return (
            <div className='placeholder'>
                <div className='placeholder-spinner'>
                    <Spin size='large' />
                </div>
            </div>
        );
    }

    return children;
};

export const ComponentAuth = ({ children }) => (
    <UserProvider>
        <AuthGate>{children}</AuthGate>
    </UserProvider>
);
